// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconTruckPath = 'm16.253 6.796-4.931 6.434-3.62-2.776 4.93-6.43c.806-1.052 1.983-1.731 3.148-1.816l1.184-.085.224 1.163c.22 1.148-.13 2.459-.935 3.51Zm-.693 7.714a.763.763 0 0 1-.132.64L14.35 16.62l-1.588-1.98 2.139-2.791.659 2.662ZM5.068 6.843a.727.727 0 0 1 .546-.303l2.693-.162L5.975 9.42l-2.131-.89 1.224-1.687Zm14.084-3.934L18.592 0l-2.956.214c-1.727.125-3.444 1.095-4.592 2.593L9.917 4.278l-4.42.266a2.737 2.737 0 0 0-2.052 1.131L.74 9.403l5.054 2.109 4.925 3.776 3.7 4.616 2.62-3.57a2.78 2.78 0 0 0 .466-2.293l-1.047-4.224 1.382-1.804c1.148-1.496 1.638-3.404 1.312-5.104ZM7.434 15.007l1.56 1.25-2.107 2.629-1.56-1.25 2.107-2.63Zm-4.532 2.955 3.08-3.69-1.535-1.281-3.08 3.69 1.535 1.28Z';
var IconTruck = baseIcon('IconTruck', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconTruckPath
});
export default IconTruck;
//# sourceMappingURL=index.js.map